document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-cardvis-gallery-direction]');
  if (!button) return;

  const gallery = button.closest('media-gallery');
  const thumbnails = [...gallery.querySelectorAll('.thumbnail-list__item button.thumbnail')].filter(
    (thumbnail) => thumbnail.offsetParent !== null,
  );
  if (thumbnails.length < 2) return;

  const currentIndex = Math.max(
    0,
    thumbnails.findIndex((thumbnail) => thumbnail.getAttribute('aria-current') === 'true'),
  );
  const increment = button.dataset.cardvisGalleryDirection === 'next' ? 1 : -1;
  const nextIndex = (currentIndex + increment + thumbnails.length) % thumbnails.length;

  thumbnails[nextIndex].click();
  thumbnails[nextIndex].focus({ preventScroll: true });
});
